// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-pick-single-entry-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  padding: 0 8px 8px 8px;
}
@media (max-width: 768px) {
  .quick-pick-single-entry-container {
    max-width: 600px;
  }
}

.quick-pick-single-entry-content {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
  max-width: 900px;
}

.quick-pick-single-entry-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
  text-align: center;
}

.quick-pick-single-entry-header-text.MuiTypography-root {
  font-size: 14px !important;
  font-weight: 700 !important;
  text-decoration: underline;
  width: 100%;
  text-align: center;
}
@media (min-width: 768px) {
  .quick-pick-single-entry-header-text.MuiTypography-root {
    font-size: 24px !important;
  }
}

.quick-pick-single-entry-text.MuiTypography-root {
  font-size: 14px !important;
  font-weight: 700 !important;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
@media (min-width: 768px) {
  .quick-pick-single-entry-text.MuiTypography-root {
    font-size: 24px !important;
    margin-top: 8px;
  }
}

.quick-pick-single-entry-champ-box {
  display: flex;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (min-width: 768px) {
  .quick-pick-single-entry-champ-box {
    height: 40px;
    width: 40px;
  }
}

.quick-pick-multiple-entry-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-evenly;
  padding-bottom: 8px;
}
@media (min-width: 768px) {
  .quick-pick-multiple-entry-container {
    gap: 100px;
    max-width: 1000px;
    margin: 0 auto;
  }
}

.quick-pick-multiple-entry-content {
  display: flex;
  justify-content: center;
  gap: 32px;
  padding: 8px;
}

.quick-pick-multiple-entry-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.quick-pick-multiple-entry-header-text {
  font-size: 14px !important;
  font-weight: 700 !important;
  text-decoration: underline;
  text-align: center;
}

@media (min-width: 768px) {
  .quick-pick-multiple-entry-header-text {
    font-size: 18px !important;
  }
}
.quick-pick-multiple-entry-text {
  font-size: 12px !important;
  font-weight: 700 !important;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .quick-pick-multiple-entry-text {
    font-size: 18px !important;
    margin-top: 8px;
  }
}

.quick-pick-multiple-entry-text-small {
  font-size: 10px !important;
  font-weight: 700 !important;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .quick-pick-multiple-entry-text-small {
    font-size: 18px !important;
    margin-top: 8px;
  }
}

.quick-pick-multiple-entry-champ-box {
  display: flex;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (min-width: 768px) {
  .quick-pick-multiple-entry-champ-box {
    height: 40px;
    width: 40px;
  }
}

.quick-pick-multiple-entry-champ-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/UserDash/UserDashComponents/QuickPickGame/QuickPickGamesStyles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;AACJ;AACI;EATJ;IAUM,gBAAA;EAEJ;AACF;;AACE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AAEJ;;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;;AAEI;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;AACN;AACM;EAPF;IAQI,0BAAA;EAEN;AACF;;AAGI;EACE,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAAN;AAEM;EATF;IAUI,0BAAA;IACA,eAAA;EACN;AACF;;AAIE;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGI;EATF;IAUI,YAAA;IACA,WAAA;EAAJ;AACF;;AASE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,mBAAA;AANJ;AAQI;EARF;IASM,UAAA;IACA,iBAAA;IACA,cAAA;EALN;AACF;;AAQA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AALJ;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AALJ;;AAQA;EACI,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,kBAAA;AALJ;;AAQA;EACI;IACI,0BAAA;EALN;AACF;AAQA;EACI,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAQI;EARJ;IASQ,0BAAA;IACA,eAAA;EALN;AACF;;AAQA;EACI,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAOI;EARJ;IASQ,0BAAA;IACA,eAAA;EAJN;AACF;;AAOA;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAMI;EATJ;IAUQ,YAAA;IACA,WAAA;EAHN;AACF;;AAOA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAJJ","sourcesContent":[".quick-pick-single-entry-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n    max-width: 80%;\n    margin: 0 auto;\n    padding: 0 8px 8px 8px;\n\n    @media (max-width: 768px) {\n      max-width: 600px;\n    }\n  }\n  \n  .quick-pick-single-entry-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    width: 100%;\n    max-width: 900px; // MUI's md breakpoint\n  }\n  \n  .quick-pick-single-entry-column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;  // Centers children horizontally\n    min-width: 80px;     // Ensures consistent width for columns\n    text-align: center;  // Centers text content\n  }\n  \n  .quick-pick-single-entry-header-text {\n    &.MuiTypography-root {\n      font-size: 14px !important;\n      font-weight: 700 !important;\n      text-decoration: underline;\n      width: 100%;       // Takes full width of parent\n      text-align: center;// Centers the text\n      \n      @media (min-width: 768px) {\n        font-size: 24px !important;\n      }\n    }\n  }\n  \n  .quick-pick-single-entry-text {\n    &.MuiTypography-root {\n      font-size: 14px !important;\n      font-weight: 700 !important;\n      height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center; // Centers content horizontally\n      width: 100%;            // Takes full width of parent\n      \n      @media (min-width: 768px) {\n        font-size: 24px !important;\n        margin-top: 8px;\n      }\n    }\n  }\n  \n  \n  .quick-pick-single-entry-champ-box {\n    display: flex;\n    border-radius: 4px;\n    height: 24px;\n    width: 24px;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    @media (min-width: 768px) {\n      height: 40px;\n      width: 40px;\n    }\n  }\n\n\n\n\n\n\n\n  .quick-pick-multiple-entry-container {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    justify-content: space-evenly;\n    padding-bottom: 8px;\n\n    @media (min-width: 768px) {\n        gap: 100px;\n        max-width: 1000px;\n        margin: 0 auto;\n    }\n}\n\n.quick-pick-multiple-entry-content {\n    display: flex;\n    justify-content: center;\n    gap: 32px;\n    padding: 8px;\n}\n\n.quick-pick-multiple-entry-column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 80px;\n}\n\n.quick-pick-multiple-entry-header-text {\n    font-size: 14px !important;\n    font-weight: 700 !important;\n    text-decoration: underline;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .quick-pick-multiple-entry-header-text {\n        font-size: 18px !important;\n    }\n}\n\n.quick-pick-multiple-entry-text {\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (min-width: 768px) {\n        font-size: 18px !important;\n        margin-top: 8px;\n    }\n}\n\n.quick-pick-multiple-entry-text-small {\n    font-size: 10px !important;\n    font-weight: 700 !important;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (min-width: 768px) {\n        font-size: 18px !important;\n        margin-top: 8px;\n    }\n}\n\n.quick-pick-multiple-entry-champ-box {\n    display: flex;\n    border-radius: 4px;\n    height: 24px;\n    width: 24px;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    @media (min-width: 768px) {\n        height: 40px;\n        width: 40px;\n    }\n}\n\n\n.quick-pick-multiple-entry-champ-logo {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
